<template>
  <div>
    <!-- Slot pour le bouton ou déclencheur -->
    <span @click="open">
      <slot>
        <!-- Fallback si aucun slot n'est fourni -->
        <button class="button is-small is-link">
          <span class="icon"><i class="fas fa-tags"></i></span>
          <span>Manage Analytics</span>
        </button>
      </slot>
    </span>

    <div class="modal" :class="{ 'is-active': showModal }">
      <div class="modal-background" @click="close"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Manage Analytical Codes</p>
          <button class="delete" aria-label="close" @click="close"></button>
        </header>

        <section class="modal-card-body">
          <!-- Concept picker -->
          <div class="field">
            <label class="label">Select Concept</label>
            <div class="control">
              <div class="select is-fullwidth">
                <select v-model="selectedConceptId" @change="loadCodes">
                  <option :value="null" disabled>Select a concept...</option>
                  <option v-for="c in concepts" :key="c.id" :value="c.id">
                    {{ c.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <!-- Codes as selectable tags -->
          <div v-if="codes.length > 0">
            <label class="label">Codes</label>
            <div class="tags">
              <span
                v-for="code in codes"
                :key="code.id"
                class="tag is-medium"
                :class="{
                  'is-success': selectedCodes.includes(code.id),
                  'is-light': !selectedCodes.includes(code.id),
                  'is-clickable': true,
                }"
                @click="toggleCode(code.id)"
              >
                {{ code.label }}
              </span>
            </div>
          </div>
        </section>

        <footer class="modal-card-foot">
          <button class="button is-success" @click="save">
            <span class="icon"><i class="fas fa-save"></i></span>
            <span>Save</span>
          </button>
          <button class="button" @click="close">Cancel</button>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/utils/axios';

export default {
  props: {
    objectId: { type: Number, required: true }, // id du document / item / third_party
    scope: { type: String, required: true }, // "document" | "item" | "third_party"
    endpoint: { type: String, required: true }, // "/documents" | "/items" | "/third-parties"
  },
  data() {
    return {
      showModal: false,
      concepts: [],
      codes: [],
      selectedConceptId: null,
      selectedCodes: [],
    };
  },
  methods: {
    async open() {
      this.showModal = true;

      // 1) Charger les concepts filtrés par scope
      const resConcepts = await api.get(
        `/analytics/concepts/?scope=${this.scope}`
      );
      this.concepts = resConcepts.data;

      // 2) Charger l’objet avec expand=analytical_codes
      const resObj = await api.get(
        `${this.endpoint}/${this.objectId}/?expand=analytical_codes`
      );
      this.selectedCodes = resObj.data.analytical_code_ids_read || [];

      this.selectedConceptId = null;
      this.codes = [];
    },
    close() {
      this.showModal = false;
    },
    async loadCodes() {
      if (!this.selectedConceptId) return;
      const res = await api.get(
        `/analytics/codes/?concept=${this.selectedConceptId}`
      );
      this.codes = res.data;
    },
    toggleCode(codeId) {
      if (this.selectedCodes.includes(codeId)) {
        this.selectedCodes = this.selectedCodes.filter((id) => id !== codeId);
      } else {
        this.selectedCodes.push(codeId);
      }
    },
    async save() {
      await api.patch(`${this.endpoint}/${this.objectId}/`, {
        analytical_code_ids: this.selectedCodes,
      });
      this.$emit('updated');
      this.close();
    },
  },
};
</script>

<style scoped>
.tag.is-clickable {
  cursor: pointer;
}
</style>
